import { Button, Checkbox, Input, Modal, Select } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestInspectionContentExport } from "redux/actions";
import _ from "lodash";

const { Option } = Select;

const annotationsSelector = (state) => state.railInspection.annotations.data;
const bookmarksSelector = (state) => state.railInspection.bookmarks;
const routeIDSelector = (state) => state.playlist.data.routeID;

const ExportContentModal = ({ displayModal, closeModal }) => {
    const [exportOption, setExportOption] = useState(0);
    const [includeImages, setIncludeImages] = useState(true);
    const [exportName, setExportName] = useState("");

    const annotations = useSelector(annotationsSelector);
    const bookmarks = useSelector(bookmarksSelector);
    const routeID = useSelector(routeIDSelector);

    const dispatch = useDispatch();

    const dropdownOptions = useMemo(() => {
        const selectOptions = [];
        if (bookmarks && bookmarks.length && annotations && annotations.length) {
            selectOptions.push({ value: 0, label: "Annotations & Bookmarks" });
        }
        if (annotations && annotations.length) {
            selectOptions.push({ value: 1, label: "Annotations Only" });
        }
        if (bookmarks && bookmarks.length) {
            selectOptions.push({ value: 2, label: "Bookmarks Only" });
        }

        return selectOptions;
    }, [annotations, bookmarks]);

    useEffect(() => {
        const first = _.get(dropdownOptions, [0, "value"]);
        if (!_.isNil(first)) {
            setExportOption(first);
        }
    }, [dropdownOptions]);

    const closeExportModal = useCallback(() => {
        setExportName("");
        setIncludeImages(true);
        closeModal();
    }, [closeModal]);

    const exportAnnotationsAndBookmarks = useCallback(() => {
        const filters = { include_images: includeImages };
        if (exportOption === 0) {
            filters.bookmarks = true;
            filters.annotations = true;
        } else if (exportOption === 1) {
            filters.bookmarks = false;
            filters.annotations = true;
        } else if (exportOption === 2) {
            filters.bookmarks = true;
            filters.annotations = false;
        }
        dispatch(requestInspectionContentExport(routeID, exportName, filters));
        closeModal();
    }, [includeImages, exportOption, dispatch, routeID, exportName, closeModal]);

    return (
        <Modal
            visible={displayModal}
            title="Export Annotations and Bookmarks"
            onCancel={() => closeModal}
            className="inspectRail__tab__exportModal"
            footer={[
                <Button onClick={() => closeExportModal()}>Cancel</Button>,
                <Button
                    disabled={!exportName}
                    type="primary"
                    onClick={exportAnnotationsAndBookmarks}>
                    Export
                </Button>,
            ]}>
            <Input
                placeholder="Export name"
                value={exportName}
                onChange={(e) => setExportName(e.target.value)}
                style={{ marginBottom: "10px" }}
            />
            <Select
                value={exportOption}
                onChange={(e) => setExportOption(e)}
                className="inspectRail__tab__exportSelect"
                style={{ width: "100%" }}>
                {_.map(dropdownOptions, (option) => (
                    <Option value={option.value}>{option.label}</Option>
                ))}
            </Select>
            <div className="inspectRail__tab__exportCheck">
                <Checkbox
                    checked={includeImages}
                    onChange={(e) => setIncludeImages(e.target.checked)}>
                    Include Images
                </Checkbox>
            </div>
        </Modal>
    );
};

export default ExportContentModal;
